// extracted by mini-css-extract-plugin
export default {"articlePageWrapper":"styles_articlePageWrapper__hVUD6","titleWrapper":"styles_titleWrapper__HzE73"};